import { Container, Row } from "reactstrap";
import { CheckboxAndRadioTitle, FormControlsTitle } from "../../../../../constants";
import AnimatedButtons from "./AnimatedButtons";
import BasicRadioAndCheckbox from "./BasicRadioAndCheckbox";
import CustomCheckbox from "./customCheckbox";
import CustomRadio from "./customRadio";
import DefaultCheckbox from "./DefaultCheckbox";
import DefaultRadio from "./DefaultRadio";
import DefaultSwitches from "./DefaultSwitches";
import ImagesWithCheckbox from "./ImagesWithCheckbox";
import ImagesWithRadio from "./ImagesWithRadio";
import InlineInputTypes from "./inlineInputTypes";
import OutlinedCheckboxStyles from "./OutlinedCheckboxStyles";
import RadioToggleButtons from "./RadioToggleButtons";
import Breadcrumbs from "../../../../../coreComponents/breadcrumbs";

const CheckboxAndRadioContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={CheckboxAndRadioTitle} parent={FormControlsTitle} />
      <Container fluid>
        <Row>
          <DefaultCheckbox />
          <CustomCheckbox />
          <DefaultRadio />
          <ImagesWithCheckbox />
          <ImagesWithRadio />
          <CustomRadio />
          <DefaultSwitches />
          <InlineInputTypes />
          <AnimatedButtons />
          <BasicRadioAndCheckbox />
          <RadioToggleButtons />
          <OutlinedCheckboxStyles />
        </Row>
      </Container>
    </>
  );
};
export default CheckboxAndRadioContainer;
